<template>
  <LegalAndPrivacyLayout :headingLocalizerKey="t('activate_privacy_policy')" :policyType="policyType" />
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { UserPolicyType } from 'src/constants/enums';
import LegalAndPrivacyLayout from 'src/components/layouts/LegalAndPrivacyLayout.vue';
import { useSessionStore } from '@/store';
import {useI18n} from 'vue-i18n';
const {t}= useI18n();

const sessionModule = useSessionStore();
const policyType = computed(() => sessionModule.isMedstratHoldingTankUser ? UserPolicyType.MedstratPrivacy : UserPolicyType.UserPolicyPrivacyPolicy);
</script>
